import { IVersionedChoice, PropertySheet, PropertySheetCategory, TypedCardElementPeer } from "adaptivecards-designer";
import {  getPropertyEditorInstance, PickerBase, PropertyKeys } from "./PickerBase";
import {  removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";

export class TeamPicker extends PickerBase{
    static readonly JsonTypeName = "Team";
    static readonly ElementId = "Ticket.Team";
    static readonly defaultLabel = "Team";
    static pickerChoices: any[];

    protected internalRender(): HTMLElement | undefined {
        this.id = TeamPicker.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = TeamPicker.defaultLabel;

        if(TeamPicker.pickerChoices){
            this.displayChoices = TeamPicker.pickerChoices;
        }
        
        return super.internalRender();
    }
    
    getJsonTypeName(): string {
        return TeamPicker.JsonTypeName;
    }
}

export class TeamPickerPeer extends TypedCardElementPeer<TeamPicker> {
    static displayLabelProperty = getPropertyEditorInstance(TeamPicker.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(TeamPicker.ElementId, PropertyKeys.requireField);
    static dataSourceProperty = getPropertyEditorInstance(TeamPicker.ElementId, PropertyKeys.dataSource, []);
    
    static updateChoices(choices: IVersionedChoice[]) {
        this.dataSourceProperty = getPropertyEditorInstance(TeamPicker.ElementId, PropertyKeys.dataSource, choices);
    }
    
    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        
        super.populatePropertySheet(propertySheet, defaultCategory);
        
        removeOtherPropertyConfigurations(propertySheet);
        propertySheet.add(
            defaultCategory,
            TeamPickerPeer.idProperty,
            TeamPickerPeer.displayLabelProperty,
            TeamPickerPeer.requireFieldProperty,
            TeamPickerPeer.dataSourceProperty);
    }
}
